// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"269ef7d7","468":"d0e4a3eb","616":"73db1600","673":"32307695","772":"a6bf1240","903":"362f4664"}[chunkId] + ".chunk.js";
};